// extracted by mini-css-extract-plugin
export default {"container":"ProjectContent_container__rf5gB"};